var _path, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcomerceSample(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90025 21.5585C7.40305 21.799 7.19492 22.397 7.43538 22.8941L8.36295 24.8121L33.1629 12.8183L32.2353 10.9003C31.9949 10.4031 31.3969 10.195 30.8997 10.4354L7.90025 21.5585ZM34.5258 15.6365L9.72588 27.6303L14.197 36.8755C14.4375 37.3727 15.0355 37.5808 15.5327 37.3404L38.5321 26.2173C39.0293 25.9768 39.2374 25.3788 38.997 24.8817L34.5258 15.6365Z",
    fill: "#9EBAF2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.4324,
    y: 18.2266,
    width: 28.3481,
    height: 20.1136,
    rx: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3152,
    y: 20.1162,
    width: 27.5479,
    height: 17.5306,
    rx: 1,
    fill: "#C9DBFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1924,
    y: 23.2461,
    width: 5.6348,
    height: 3.13046,
    rx: 0.24867,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcomerceSample);
export default __webpack_public_path__ + "static/media/ecomerce_sample.08dfcc2a.svg";
export { ForwardRef as ReactComponent };